// import dayjs from "dayjs";
// const minxs: minxs.Minxs = {
//   filters: {
//     money: v => parseInt(v).toLocaleString(),
//     formatFloat: v => parseFloat(`${v}`).toFixed(2),
//     formatDay: v => dayjs.unix(v).format("YYYY-MM-DD"),
//     formatDate: v => dayjs(v).format("YYYY-MM-DD"),
//     formatFloatByorder: v => parseFloat(`${+v / 100}`).toFixed(2)
//   }
// };

// export default minxs;

import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  filters: {
    money: (v: string) => parseInt(v).toLocaleString(),
    formatFloat: (v: number) => parseFloat(`${v}`).toFixed(2),
    formatDay: (v: number) => dayjs.unix(v).format("YYYY-MM-DD"),
    formatDate: (v: string) => dayjs(v).format("YYYY-MM-DD"),
    formatFloatByorder: (v: number | string) =>
      parseFloat(`${+v / 100}`).toFixed(2)
  }
})
export default class Minxss extends Vue {}
